<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
            이력서 제목
            <span v-if="mode == 'form'" class="page-text pink--text pl-8 font-weight-medium">(필수)</span>
            <!-- <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">경력 작성시 더 좋은 일자리를 구할 수 있습니다.</span> -->
        </h5>
        <v-sheet>
            <vertical-form-table v-model="resume" v-bind="{ mode, items }" @input="emit" />
        </v-sheet>
    </v-sheet>
</template>

<script>
import { attrs_input, initResume } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "name",
        term: "이력서 제목",
        type: "text",
        required: true,
        headerProps: {
            class: "d-none",
        },
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(), ...this.value };
        },
        emit() {
            let { name } = this.resume;
            this.$emit("input", { ...this.value, name });
        },
    },
};
</script>
